// frontend/src/config/version.ts
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.2';

export const checkVersion = () => {
    const savedVersion = localStorage.getItem('appVersion');
    if (savedVersion !== APP_VERSION) {
        localStorage.setItem('appVersion', APP_VERSION);
        // Force reload if this is not the first load and version changed
        if (savedVersion) {
            window.location.reload();
        }
    }
};

checkVersion();